function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18.2075,
  stroke: "#023C40",
  strokeWidth: 0.584906
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.728 16.6568L21.314 15.2428L12 24.5568V25.9708H13.414L22.728 16.6568ZM24.142 15.2428L25.556 13.8288L24.142 12.4148L22.728 13.8288L24.142 15.2428ZM14.242 27.9708H10V23.7278L23.435 10.2928C23.6225 10.1053 23.8768 10 24.142 10C24.4072 10 24.6615 10.1053 24.849 10.2928L27.678 13.1218C27.8655 13.3093 27.9708 13.5636 27.9708 13.8288C27.9708 14.094 27.8655 14.3483 27.678 14.5358L14.243 27.9708H14.242Z",
  fill: "#023C40"
});

function SvgExpertise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.7f961f30.svg";
export { ForwardRef as ReactComponent };